// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'

import Colors from 'components/styles/colors'

export type PropTypes = {
  hasAdditionalFee?: ?boolean,
  paymentMethodType?: ?'company' | 'creditcard' | 'postpay' | 'paidy',
  changedBy: 'host' | 'guest',
}

const PayNoticeText = styled.div`
  text-align: center;
  color: ${Colors.red};
  font-weight: bold;
  font-size: ${fontSize.small_3}px;
  line-height: 1.4;
  margin-top: ${spacing.medium_2}px;
  ${mediaMin.phone`
    margin-top: ${spacing.large}px;
  `};
`
const PayNoticeTextBr = styled.br`
  ${mediaMin.phone`
    display: none;
  `};
`
const PayNoticeSubText = styled.span`
  color: ${Colors.grayB};
  font-size: ${fontSize.small_2}px;
  font-weight: normal;
  padding-top: ${spacing.small}px;
  display: block;
`

export default function ReservationAdditionalFeeBlock(props: PropTypes) {
  if (!props.hasAdditionalFee) {
    return null
  }

  return (
    <React.Fragment>
      {props.paymentMethodType === 'company' && (
        <PayNoticeText>
          {i18n.t('page.dashboard.reservation.addFeeAttention')}
          <PayNoticeTextBr />
          {i18n.t(
            props.changedBy === 'guest'
              ? 'page.dashboard.reservation.payByCorporationDescFrom.guest'
              : 'page.dashboard.reservation.payByCorporationDescFrom.host',
          )}
        </PayNoticeText>
      )}
      {props.paymentMethodType === 'creditcard' && (
        <PayNoticeText>
          {i18n.t('page.dashboard.reservation.addFeeAttention')}
          <PayNoticeTextBr />
          {i18n.t(
            props.changedBy === 'guest'
              ? 'page.dashboard.reservation.payByCreditcardDescFrom.guest'
              : 'page.dashboard.reservation.payByCreditcardDescFrom.host',
          )}
        </PayNoticeText>
      )}
      {props.paymentMethodType === 'postpay' && (
        <PayNoticeText>
          {i18n.t('page.dashboard.reservation.addFeeAttention')}
          <PayNoticeTextBr />
          {i18n.t(
            props.changedBy === 'guest'
              ? 'page.dashboard.reservation.payByPostpayDescFrom.guest'
              : 'page.dashboard.reservation.payByPostpayDescFrom.host',
          )}
        </PayNoticeText>
      )}
      {props.paymentMethodType === 'paidy' && (
        <PayNoticeText>
          {i18n.t('page.dashboard.reservation.addPaidyAttention')}
          <PayNoticeSubText>
            {i18n.t('page.dashboard.reservation.addPaidySubAttention')}
          </PayNoticeSubText>
        </PayNoticeText>
      )}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationAdditionalFeeBlock/index.jsx